import { err, ok, type Result } from 'neverthrow';
import { ZodError, z } from 'zod';

export const StationId = z.string().brand('StationId');

export const StationSchema = z.object({
	id: StationId, // station.id (= UNI_ID)
	stationName: z.string(), // station_name
	address: z.string(), // road_number_address
	coorX: z.number(), // coor_x (WGS84 위경도)
	coorY: z.number(), // coor_y (WGS84 위경도)
	stationLogo: z.string().nullable(), // station_logo
	brandCode: z
		.enum([
			'SKE',
			'GSC',
			'HDO',
			'SOL',
			'RTE',
			'RTX',
			'NHO',
			'ETC',
			'E1G',
			'SKG',
		])
		.optional(),

	// OPINET (stationsAround) 출처
	price: z.number(), // PRICE
	distance: z.number(), // DISTANCE (중심으로부터의 직선거리)
});

export const parseStation = (data: unknown): Result<Station, ZodError> => {
	const result = StationSchema.safeParse(data);
	if (!result.success) {
		return err(result.error);
	}

	return ok(result.data);
};

export interface Station extends z.infer<typeof StationSchema> {}
